import {
    AiFillCloseCircle,
    AiFillInfoCircle,
    AiFillStar,
    AiOutlineClockCircle,
    AiOutlineCompass,
    AiOutlineEye,
    AiOutlineEyeInvisible,
    AiOutlineMessage,
    AiOutlineMinusCircle,
    AiOutlinePlusCircle,
    AiOutlineQuestionCircle,
    AiOutlineSearch,
} from 'react-icons/ai';
import { BsArrowUpRight, BsFilter, BsWhatsapp } from 'react-icons/bs';
import { CgSelect } from 'react-icons/cg';
import { CiFilter } from 'react-icons/ci';
import {
    FaCircle,
    FaClone,
    FaGraduationCap,
    FaQuoteLeft,
    FaRegCheckCircle,
    FaRegCircle,
} from 'react-icons/fa';
import { FaCircleCheck, FaLock } from 'react-icons/fa6';
import {
    FiArrowLeft,
    FiArrowRight,
    FiCalendar,
    FiCheck,
    FiChevronDown,
    FiChevronLeft,
    FiChevronRight,
    FiChevronsDown,
    FiChevronsRight,
    FiChevronsUp,
    FiChevronUp,
    FiClipboard,
    FiCopy,
    FiExternalLink,
    FiInfo,
    FiLayers,
    FiLink2,
    FiMail,
    FiMenu,
    FiMessageSquare,
    FiMonitor,
    FiMoreHorizontal,
    FiMoreVertical,
    FiPauseCircle,
    FiPlus,
    FiSave,
    FiSettings,
    FiShoppingCart,
    FiSmartphone,
    FiTrash,
    FiTrendingUp,
    FiZap,
    FiZapOff,
} from 'react-icons/fi';
import { IoIosArrowForward, IoMdArrowDown, IoMdArrowUp } from 'react-icons/io';
import { IoEllipsisHorizontal } from 'react-icons/io5';
import {
    MdClose,
    MdErrorOutline,
    MdExpandLess,
    MdExpandMore,
    MdFilterAlt,
    MdMood,
    MdOutlineKeyboardArrowLeft,
    MdOutlineKeyboardArrowRight,
} from 'react-icons/md';
import {
    PiEyeLight,
    PiPencilSimpleLight,
    PiShuffleSimpleLight,
    PiTagSimple,
    PiUsers,
} from 'react-icons/pi';
import { RiAwardLine } from 'react-icons/ri';
import { RxCaretUp, RxDragHandleDots2 } from 'react-icons/rx';
import { TbUserScan } from 'react-icons/tb';

import cta from '../images/components/cta.svg?react';
import gift from '../images/components/gift.svg?react';
import handWave from '../images/components/handWave.svg?react';
import heart from '../images/components/heart.svg?react';
import other from '../images/components/other.svg?react';
import picture from '../images/components/picture.svg?react';
import tada from '../images/components/tada.svg?react';
import tag from '../images/components/tag.svg?react';
import AccelerationIcon from '../images/custom-components/colorless/accleration.svg?react';
import AirBikeIcon from '../images/custom-components/colorless/air-bike.svg?react';
import ApplicationOneIcon from '../images/custom-components/colorless/application-one.svg?react';
import ApplicationIcon from '../images/custom-components/colorless/application.svg?react';
import BackpackIcon from '../images/custom-components/colorless/backpack.svg?react';
import BriefCaseIcon from '../images/custom-components/colorless/briefcase.svg?react';
import CalendarIcon from '../images/custom-components/colorless/calendar.svg?react';
import CameraIcon from '../images/custom-components/colorless/cameraIcon.svg?react';
import CityIcon from '../images/custom-components/colorless/city.svg?react';
import ColorCardIcon from '../images/custom-components/colorless/color-card.svg?react';
import ConceptSharingIcon from '../images/custom-components/colorless/conceptSharing.svg?react';
import CuisineIcon from '../images/custom-components/colorless/cuisine.svg?react';
import DataIcon from '../images/custom-components/colorless/data.svg?react';
import DribbleIcon from '../images/custom-components/colorless/dribble.svg?react';
import ElectroCardiogramIcon from '../images/custom-components/colorless/electrocardiogram.svg?react';
import Flag from '../images/custom-components/colorless/flag.svg?react';
import GiftBoxIcon from '../images/custom-components/colorless/gift-box.svg?react';
import GreenNewEnergyIcon from '../images/custom-components/colorless/green-new-energy.svg?react';
import HourglassIcon from '../images/custom-components/colorless/hourglass.svg?react';
import IphoneIcon from '../images/custom-components/colorless/iphone.svg?react';
import LightningIcon from '../images/custom-components/colorless/lightning.svg?react';
import ListOneIcon from '../images/custom-components/colorless/list-one.svg?react';
import MusicToneIcon from '../images/custom-components/colorless/musicTone.svg?react';
import NewPictureIcon from '../images/custom-components/colorless/new-picture.svg?react';
import OptimizeIcon from '../images/custom-components/colorless/optimize.svg?react';
import ParkPicIcon from '../images/custom-components/colorless/parkPic.svg?react';
import ReelIcon from '../images/custom-components/colorless/reel.svg?react';
import RocketIcon from '../images/custom-components/colorless/rocket.svg?react';
import SettingLaptopIcon from '../images/custom-components/colorless/setting-laptop.svg?react';
import ShieldIcon from '../images/custom-components/colorless/shield.svg?react';
import SmilingFaceIcon from '../images/custom-components/colorless/smilingFace.svg?react';
import SneakerIcon from '../images/custom-components/colorless/sneaker.svg?react';
import SquaresFourIcon from '../images/custom-components/colorless/squaresFour.svg?react';
import StickersIcon from '../images/custom-components/colorless/stickers.svg?react';
import TicketOneIcon from '../images/custom-components/colorless/ticket-one.svg?react';
import TicketTwoIcon from '../images/custom-components/colorless/tickets-two.svg?react';
import TreadmillIcon from '../images/custom-components/colorless/treadmill-one.svg?react';
import ViewGridListIcon from '../images/custom-components/colorless/view-grid-list.svg?react';
import ViewListIcon from '../images/custom-components/colorless/view-list.svg?react';

import ApproximateEquals from '../images/ApproximateEquals.svg?react';
// new navbar icons
import BlankImage from '../images/BlankImage.svg?react';
// images
import Brain from '../images/Brain.svg?react';
import BullHorn from '../images/BullHorn.svg?react';
import CallToAction from '../images/CallToAction.svg?react';
import CallToActionNew from '../images/CallToActionNew.svg?react';
import doubleRightArrow from '../images/CaretDoubleRight.svg?react';
import ChatGpt from '../images/ChatGpt.svg?react';
import EditPencil from '../images/EditPencil.svg?react';
import EmptyIntegrationsIcon from '../images/EmptyIntegrationsIcon.svg?react';
import FeaturedIcon from '../images/Featured icon.svg?react';
import FileX from '../images/FileX.svg?react';
import Conversion from '../images/FunnelConversionIcon.svg?react';
import Impression from '../images/FunnelImpressionIcon.svg?react';
import Intention from '../images/FunnelIntentionIcon.svg?react';
import Greeting from '../images/Greeting.svg?react';
import GreetingNew from '../images/GreetingNew.svg?react';
import gridNine from '../images/GridNine.svg?react';
import ImageError from '../images/ImageError.svg?react';
import ImageVariant from '../images/ImageVariant.svg?react';
import InAppBannerIcon from '../images/InAppBanner.svg?react';
import InAppFullPageIcon from '../images/InAppFullpage.svg?react';
import Incentive from '../images/Incentive.svg?react';
import IncentiveNew from '../images/IncentiveNew.svg?react';
import MagnifyingGlass from '../images/MagnifyingGlass.svg?react';
import MagnifyingGlassX from '../images/MagnifyingGlassX.svg?react';
import MinusSquare from '../images/MinusSquare.svg?react';
import NavCollapse from '../images/NavCollapse.svg?react';
import NavExpand from '../images/NavExpand.svg?react';
import Note from '../images/Note.svg?react';
import Offering from '../images/Offering.svg?react';
import OfferingNew from '../images/OfferingNew.svg?react';
import Other from '../images/Other.svg?react';
import OtherNew from '../images/OtherNew.svg?react';
import Prohibit from '../images/Prohibit.svg?react';
import Sparkle from '../images/Sparkle.svg?react';
import Tone from '../images/Tone.svg?react';
import ToneNew from '../images/ToneNew.svg?react';
import ValueProposition from '../images/ValueProposition.svg?react';
import ValuePropositionNew from '../images/ValuePropositionNew.svg?react';
import addButton from '../images/add-button.svg?react';
import cmsPlaceholder from '../images/add-cms-placeholder.svg?react';
import imageAlternate from '../images/add-image-alternate.svg?react';
import AdminShield from '../images/adminShield.svg?react';
import AlternateLock from '../images/alternate-lock.svg?react';
import AlternateFaceIcon1 from '../images/alternatesFaceIcon1.svg?react';
import AlternateFaceIcon2 from '../images/alternatesFaceIcon2.svg?react';
import AlternateFaceIcon3 from '../images/alternatesFaceIcon3.svg?react';
import AlternateFaceIcon4 from '../images/alternatesFaceIcon4.svg?react';
import AlternateFaceIcon5 from '../images/alternatesFaceIcon5.svg?react';
import Archive from '../images/archive.svg?react';
import ArrowCircleDragDrop from '../images/arrow-circle-broken-down.svg?react';
import ArrowDownIcon from '../images/arrowDown.svg?react';
import ArrowUpIcon from '../images/arrowUp.svg?react';
import calendarDetail from '../images/calendarIcon.svg?react';
import Checkmark from '../images/checkmark.svg?react';
import Click from '../images/click.svg?react';
import ConnectedStatus from '../images/connected-status.svg?react';
import ContentCards from '../images/content_card.svg?react';
import ImageContentCard from '../images/contentcardimage.svg?react';
import ImageAndTextContentCard from '../images/contentcardimageandtext.svg?react';
import TextContentCard from '../images/contentcardtext.svg?react';
import coverSwirl2 from '../images/coverSwirl2.svg?react';
import coverSwirl3 from '../images/coverSwirl3.svg?react';
//background swirls
import coverSwirl from '../images/coverSwirl.svg?react';
import CreativeIdea from '../images/creativeIdea.svg?react';
import CollapseIcon from '../images/cross.svg?react';
import DelayClock from '../images/delayClock.svg?react';
import Delete from '../images/delete.svg?react';
import DocumentationIcon from '../images/documentationIcon.svg?react';
import DownloadIcon from '../images/download.svg?react';
import DragArrow from '../images/dragArrow.svg?react';
import EmptyFrame from '../images/empty-frame.svg?react';
import EventManagementPage from '../images/eventManagementPage.svg?react';
import EventStage from '../images/eventStage.svg?react';
import EventType from '../images/eventType.svg?react';
import exclamatoryMark from '../images/exclamatory_mark.svg?react';
import ExitArrow from '../images/exitArrow.svg?react';
import ExpandIcon from '../images/expand.svg?react';
import Figma from '../images/figma.svg?react';
import FigmaColoredIcon from '../images/figmaColoredIcon.svg?react';
import FilledFrame from '../images/filled-frame.svg?react';
import GenAiIcon from '../images/genAiIcon.svg?react';
import Grouped from '../images/grouped.svg?react';
import HomeIcon from '../images/homeIcon.svg?react';
import DropdownChevron from '../images/icon-park-outline_down-one.svg?react';
import TrashX from '../images/iconoir_plus.svg?react';
import RefreshDouble from '../images/iconoir_refresh-double.svg?react';
import InfoCircle from '../images/info-circle.svg?react';
import InspirationIcon from '../images/inspirationIcon.svg?react';
import labelHistory from '../images/label-history.svg?react';
import labelAgent01 from '../images/labelAgent01.svg?react';
import labelAgent02 from '../images/labelAgent02.svg?react';
import labelAgent03 from '../images/labelAgent03.svg?react';
import labelAgent04 from '../images/labelAgent04.svg?react';
import labelAgent05 from '../images/labelAgent05.svg?react';
import labelAgent06 from '../images/labelAgent06.svg?react';
import labelAgent07 from '../images/labelAgent07.svg?react';
import LearnVideoIcon from '../images/learnVideoIcon.svg?react';
import FullLightning from '../images/lightning.svg?react';
import LinePencil from '../images/linePencil.svg?react';
import lock from '../images/lock.svg?react';
import aampeLogo from '../images/logos/logoOnly.svg?react';
import Logout from '../images/logout.svg?react';
import MessageIcon from '../images/messageIcon.svg?react';
import MessageSequencing from '../images/messageSequencing.svg?react';
import MessageSettingsIcon from '../images/messageSettingsIcon.svg?react';
import MonitoringIcon from '../images/monitoringIcon.svg?react';
import OpenBook from '../images/openBook.svg?react';
import Paste from '../images/paste.svg?react';
import Pencil from '../images/pencil.svg?react';
import PendingStatus from '../images/pending-status.svg?react';
import Performance from '../images/performance-icon.svg?react';
import Random from '../images/random.svg?react';
import RedirectArrow from '../images/redirect-arrow.svg?react';
import Robot from '../images/robot.svg?react';
import SadFaceIcon from '../images/sad-face.svg?react';
import SettingsIcon from '../images/settingsIcon.svg?react';
import Sidebar from '../images/sidebar.svg?react';
import SliderCurveLeft from '../images/slider-curve-left.svg?react';
import SliderCurveRight from '../images/slider-curve-right.svg?react';
import HappyFaceIcon from '../images/smiling-face.svg?react';
import StartArrow from '../images/startArrow.svg?react';
import Surface from '../images/surface.svg?react';
// Tables
import AddColumn from '../images/tables/addColumn.svg?react';
import AddRow from '../images/tables/addRow.svg?react';
import TabulationIcon from '../images/tabulation.svg?react';
import Target from '../images/target.svg?react';
import testMessage from '../images/test-message.svg?react';
import Ticket from '../images/ticket.svg?react';
import Trophy from '../images/trophy-01.svg?react';
import Unarchive from '../images/unarchive.svg?react';
import unLock from '../images/unlock.svg?react';
import User from '../images/user.svg?react';
import Vector from '../images/vector.svg?react';
import WarningIcon from '../images/warning.svg?react';
import XIcon from '../images/xCloseIcon.svg?react';

const ICONS = {
    // APP SECTIONS
    home: HomeIcon,
    messages: MessageIcon,
    messagesEmpty: FiMessageSquare,
    datasets: FiLayers,
    cart: FiShoppingCart,
    monitoring: MonitoringIcon,
    messageSettings: MessageSettingsIcon,
    systemSetup: SettingsIcon,
    inspiration: InspirationIcon,
    genAi: GenAiIcon,
    learn: FaGraduationCap,
    documentation: DocumentationIcon,
    snippets: FiZap,
    chatGpt: ChatGpt,
    expandNav: NavExpand,
    collapseNav: NavCollapse,
    messageSequencing: MessageSequencing,
    surface: Surface,
    componentsLabels: PiTagSimple,
    gridNine: gridNine,

    // ACTIONS / INTERFACE
    arrowForward: IoIosArrowForward,
    archive: Archive,
    close: MdClose,
    check: FiCheck,
    checkmark: Checkmark,
    circleCheck: FaCircleCheck,
    circleCross: AiFillCloseCircle,
    card: FiClipboard,
    calendar: FiCalendar,
    chart: FiTrendingUp,
    carouselDot: FaCircle,
    delete: Delete,
    emoji: MdMood,
    expandLess: MdExpandLess,
    expandMore: MdExpandMore,
    filter: BsFilter,
    info: FiInfo,
    fillInfo: AiFillInfoCircle,
    leftArrow: FiArrowLeft,
    more: FiMoreHorizontal,
    pause: FiPauseCircle,
    plus: FiPlus,
    rightArrow: FiArrowRight,
    rightChevron: FiChevronRight,
    rightChevrons: FiChevronsRight,
    leftChevron: FiChevronLeft,
    downChevrons: FiChevronsDown,
    chevronDown: FiChevronDown,
    chevronUp: FiChevronUp,
    upChevrons: FiChevronsUp,
    ellipses: IoEllipsisHorizontal,
    save: FiSave,
    settings: FiSettings,
    trash: FiTrash,
    trashX: TrashX,
    unarchive: Unarchive,
    verticalMore: FiMoreVertical,
    search: AiOutlineSearch,
    searchV2: MagnifyingGlass,
    compactLeftArrow: MdOutlineKeyboardArrowLeft,
    compactRightArrow: MdOutlineKeyboardArrowRight,
    compass: AiOutlineCompass,
    upRightArrow: BsArrowUpRight,
    pencil: Pencil,
    click: Click,
    caretUp: RxCaretUp,
    select: CgSelect,
    calendarDetail: calendarDetail,
    // Formula types
    mobilePush: FiSmartphone,
    webPush: FiMonitor,
    whatsapp: BsWhatsapp,
    sms: AiOutlineMessage,
    inAppBanner: InAppBannerIcon,
    inAppFullPage: InAppFullPageIcon,
    contentCards: ContentCards,
    crossLightning: FiZapOff,
    lightning: FullLightning,
    email: FiMail,
    bullHorn: BullHorn,
    // live-messages
    performance: Performance,
    externalLink: FiExternalLink,
    addLink: FiLink2,
    // integration-tracker
    regCircle: FaRegCircle,
    regCheckCircle: FaRegCheckCircle,
    eye: AiOutlineEye,
    eyeSlash: AiOutlineEyeInvisible,
    // multi-use
    clone: FaClone,
    copy: FiCopy,
    clipBoard: FiClipboard,
    learnVideo: LearnVideoIcon,
    question: AiOutlineQuestionCircle,
    // components
    greeting: Greeting,
    valueProposition: ValueProposition,
    incentive: Incentive,
    offering: Offering,
    callToAction: CallToAction,
    other: Other,
    tone: Tone,
    sidebar: Sidebar,

    // new components
    greetingNew: GreetingNew,
    valuePropositionNew: ValuePropositionNew,
    incentiveNew: IncentiveNew,
    offeringNew: OfferingNew,
    callToActionNew: CallToActionNew,
    otherNew: OtherNew,
    toneNew: ToneNew,
    imageVariant: ImageVariant,

    verticalDrag: RxDragHandleDots2,
    arrowDragDrop: ArrowCircleDragDrop,
    featuredTick: FeaturedIcon,
    fileX: FileX,
    fillStar: AiFillStar,
    magnifyingGlassX: MagnifyingGlassX,
    trophy: Trophy,
    plusIcon: AiOutlinePlusCircle,
    minusIcon: AiOutlineMinusCircle,
    award: RiAwardLine,
    helpCircle: AiOutlineQuestionCircle,
    happyFaceIcon: HappyFaceIcon,
    sadFaceIcon: SadFaceIcon,
    filterIcon: MdFilterAlt,
    filterOutlined: CiFilter,
    clock: AiOutlineClockCircle,
    menuIcon: FiMenu,
    editPencil: EditPencil,
    EmptyIntegrationsIcon: EmptyIntegrationsIcon,
    blankImage: BlankImage,
    imageError: ImageError,
    imageContentCard: ImageContentCard,
    textContentCard: TextContentCard,
    imageAndTextContentCard: ImageAndTextContentCard,
    startArrow: StartArrow,
    exitArrow: ExitArrow,
    dragArrow: DragArrow,
    delayClock: DelayClock,
    error: MdErrorOutline,
    alternateLock: AlternateLock,
    random: Random,
    filledFrame: FilledFrame,
    emptyFrame: EmptyFrame,
    user: User,
    target: Target,
    vector: Vector,
    brain: Brain,
    note: Note,
    ticket: Ticket,
    openBook: OpenBook,
    logout: Logout,

    creativeIdea: CreativeIdea,
    quote: FaQuoteLeft,

    upArrow: IoMdArrowUp,
    downArrow: IoMdArrowDown,
    paste: Paste,
    figma: Figma,
    redirectArrow: RedirectArrow,

    // arrows without tail
    upArrowWithoutTail: FiChevronUp,

    // new alternate faces
    alternateFaceIcon1: AlternateFaceIcon1,
    alternateFaceIcon2: AlternateFaceIcon2,
    alternateFaceIcon3: AlternateFaceIcon3,
    alternateFaceIcon4: AlternateFaceIcon4,
    alternateFaceIcon5: AlternateFaceIcon5,
    // new label agent faces
    labelAgent01: labelAgent01,
    labelAgent02: labelAgent02,
    labelAgent03: labelAgent03,
    labelAgent04: labelAgent04,
    labelAgent05: labelAgent05,
    labelAgent06: labelAgent06,
    labelAgent07: labelAgent07,
    cmsPlaceHolder: cmsPlaceholder,
    testMessage: testMessage,
    labelHistory: labelHistory,
    imageAlternate: imageAlternate,
    addButton: addButton,
    lock: lock,
    unLock: unLock,
    warning: WarningIcon,

    coverSwirl: coverSwirl,
    coverSwirl2: coverSwirl2,
    coverSwirl3: coverSwirl3,
    robot: Robot,
    refreshDouble: RefreshDouble,
    dropdownChevron: DropdownChevron,
    pendingStatus: PendingStatus,
    connectedStatus: ConnectedStatus,

    conversion: Conversion,
    impression: Impression,
    intention: Intention,
    attributePlaceholder: TbUserScan,
    xIcon: XIcon,
    exclamatoryMark: exclamatoryMark,
    tabulation: TabulationIcon,
    grouped: Grouped,
    arrowUp: ArrowUpIcon,
    arrowDown: ArrowDownIcon,
    collapseIcon: CollapseIcon,
    expandIcon: ExpandIcon,
    figmaColored: FigmaColoredIcon,
    linePencil: LinePencil,
    downloadIcon: DownloadIcon,
    sliderCurveLeft: SliderCurveLeft,
    sliderCurveRight: SliderCurveRight,
    infoCircle: InfoCircle,
    approximateEquals: ApproximateEquals,
    prohibit: Prohibit,
    minusSquare: MinusSquare,
    sparkle: Sparkle,
    doubleRightArrow: doubleRightArrow,
    aampeLogo: aampeLogo,
    adminShield: AdminShield,
    thinLightPencil: PiPencilSimpleLight,
    thinLightEye: PiEyeLight,

    // tables
    addColumn: AddColumn,
    addRow: AddRow,

    groupUsers: PiUsers,
    eventManagementPage: EventManagementPage,
    eventType: EventType,
    EventStage: EventStage,
    simpleSuffleLight: PiShuffleSimpleLight,

    faLock: FaLock,
};

export enum CustomComponentIconKey {
    SquaresFour = 'squaresFour',
    Cta = 'cta',
    Gift = 'gift',
    HandWave = 'handWave',
    Heart = 'heart',
    Other = 'other',
    Picture = 'picture',
    Tada = 'tada',
    Tag = 'tag',
}

export const CustomComponentsIcons = {
    acceleration: { icon: AccelerationIcon, strokeColor: 'white' },
    airBike: { icon: AirBikeIcon, strokeColor: 'white' },
    applicationOne: { icon: ApplicationOneIcon, strokeColor: 'black' },
    application: { icon: ApplicationIcon, strokeColor: 'black' },
    backpack: { icon: BackpackIcon, strokeColor: 'white' },
    briefCase: { icon: BriefCaseIcon, strokeColor: 'black' },
    calendarCustomComponent: { icon: CalendarIcon, strokeColor: 'black' },
    camera: { icon: CameraIcon, strokeColor: 'white' },
    city: { icon: CityIcon, strokeColor: 'white' },
    colorCard: { icon: ColorCardIcon, strokeColor: 'black' },
    conceptSharing: { icon: ConceptSharingIcon, strokeColor: 'white' },
    cuisine: { icon: CuisineIcon, strokeColor: 'white' },
    data: { icon: DataIcon, strokeColor: 'black' },
    dribble: { icon: DribbleIcon, strokeColor: 'black' },
    electroCardiogram: { icon: ElectroCardiogramIcon, strokeColor: 'black' },
    flag: { icon: Flag, strokeColor: 'white' },
    giftBox: { icon: GiftBoxIcon, strokeColor: 'black' },
    greenNewEnergy: { icon: GreenNewEnergyIcon, strokeColor: 'white' },
    hourglass: { icon: HourglassIcon, strokeColor: 'white' },
    iphone: { icon: IphoneIcon, strokeColor: 'black' },
    lightning: { icon: LightningIcon, strokeColor: 'white' },
    listOne: { icon: ListOneIcon, strokeColor: 'white' },
    musicTone: { icon: MusicToneIcon, strokeColor: 'black' },
    newPicture: { icon: NewPictureIcon, strokeColor: 'black' },
    optimize: { icon: OptimizeIcon, strokeColor: 'white' },
    parkPic: { icon: ParkPicIcon, strokeColor: 'black' },
    reel: { icon: ReelIcon, strokeColor: 'white' },
    rocket: { icon: RocketIcon, strokeColor: 'white' },
    settingLaptop: { icon: SettingLaptopIcon, strokeColor: 'white' },
    shield: { icon: ShieldIcon, strokeColor: 'black' },
    smilingFace: { icon: SmilingFaceIcon, strokeColor: 'black' },
    sneaker: { icon: SneakerIcon, strokeColor: 'black' },
    stickers: { icon: StickersIcon, strokeColor: 'white' },
    ticketOne: { icon: TicketOneIcon, strokeColor: 'black' },
    ticketTwo: { icon: TicketTwoIcon, strokeColor: 'white' },
    treadmill: { icon: TreadmillIcon, strokeColor: 'white' },
    viewGridlist: { icon: ViewGridListIcon, strokeColor: 'black' },
    viewList: { icon: ViewListIcon, strokeColor: 'black' },
    squaresFour: { icon: SquaresFourIcon, strokeColor: 'white' },
    cta: { icon: cta, strokeColor: 'black' },
    gift: { icon: gift, strokeColor: 'black' },
    handWave: { icon: handWave, strokeColor: 'black' },
    heart: { icon: heart, strokeColor: 'black' },
    other: { icon: other, strokeColor: 'black' },
    picture: { icon: picture, strokeColor: 'black' },
    tada: { icon: tada, strokeColor: 'black' },
    tag: { icon: tag, strokeColor: 'black' },
};

export default ICONS;
